export default "__VITE_ASSET__0ce5c683__"